export const detectStateChange = (obj1, obj2) => {
    const firstObj = Object.entries(obj1);
    const secondObj = Object.entries(obj2);
    const firstObjLength = firstObj.length;
    const secondObjLength = secondObj.length;
  
    if (firstObjLength !== secondObjLength) return true;
    return false;
  };